import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Crown, Medal } from "@phosphor-icons/react";

export default function WeeklyPrizeCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/weekly-prize/current").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;

  const podium = data.top.slice(0, 3);
  const shares = [data.pool * 0.5, data.pool * 0.3, data.pool * 0.2];
  const icons = [Crown, Trophy, Medal];
  const colors = ["text-yellow-400", "text-white/80", "text-orange-400"];

  return (
    <Card
      data-testid="weekly-prize-card"
      className="bg-gradient-to-br from-yellow-500/10 via-[#121212] to-orange-500/10 border-yellow-500/30"
    >
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-yellow-300">
              Weekly Prize Pool
            </p>
            <p className="font-heading text-4xl font-black text-yellow-400 mt-1">
              ${data.pool.toFixed(2)}
            </p>
            <p className="text-xs text-white/50 mt-1">
              Week of {data.week_start} • funded from {data.prize_pct}% of publish fees
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-white/50">Distribution</p>
            <p className="text-sm font-heading font-bold">50% • 30% • 20%</p>
          </div>
        </div>

        {podium.length > 0 && (
          <div className="grid grid-cols-3 gap-2 pt-2">
            {podium.map((u, i) => {
              const Icon = icons[i];
              return (
                <div
                  key={u.user_id}
                  data-testid={`weekly-podium-${i + 1}`}
                  className="p-3 rounded-lg bg-white/5 border border-white/10 text-center"
                >
                  <Icon size={24} weight="fill" className={`mx-auto ${colors[i]}`} />
                  {u.picture ? (
                    <img
                      src={u.picture}
                      alt=""
                      className="w-10 h-10 rounded-full mx-auto mt-2 border border-white/20"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-white/10 mx-auto mt-2" />
                  )}
                  <p className="text-xs font-heading font-bold mt-1.5 truncate">{u.name}</p>
                  <p className="text-xs text-white/50">${u.weekly_earnings.toFixed(2)}</p>
                  <p className="text-xs font-bold text-yellow-400 mt-1">
                    Wins ${shares[i].toFixed(2)}
                  </p>
                </div>
              );
            })}
          </div>
        )}

        {podium.length === 0 && (
          <p className="text-sm text-white/60 text-center py-4">
            No earnings this week yet — post content and be the first!
          </p>
        )}
      </CardContent>
    </Card>
  );
}
